import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import * as React from 'react';

var _excluded$1 = ["title", "titleId"];
var CheckCircleFilled24 = function CheckCircleFilled24(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M12 .526c6.074 0 11 4.927 11 11.001 0 6.075-4.926 11-11 11-6.075 0-11-4.925-11-11 0-6.074 4.924-11 11-11Zm4.64 7.232a1 1 0 0 0-1.409.128L11 12.964l-2.231-2.678a1 1 0 0 0-1.538 1.28l3 3.601a1 1 0 0 0 1.538 0l5-6a1 1 0 0 0-.128-1.41Z"
  }));
};
CheckCircleFilled24.Size = 24;
CheckCircleFilled24.Title = "CheckCircleFilled";

var _excluded = ["title", "titleId"];
var ExclamationCircleFilled24 = function ExclamationCircleFilled24(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.526c5.522 0 10 4.479 10 10.001 0 5.523-4.478 10-10 10s-10-4.477-10-10 4.477-10 10-10Zm0 13a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m0-8.5a1 1 0 0 0-1 1v4.5a1 1 0 1 0 2 0v-4.5a1 1 0 0 0-1-1"
  }));
};
ExclamationCircleFilled24.Size = 24;
ExclamationCircleFilled24.Title = "ExclamationCircleFilled";

export { CheckCircleFilled24 as C, ExclamationCircleFilled24 as E };
//# sourceMappingURL=ExclamationCircleFilled24-ebb72701.js.map
